import React from 'react'

import '../BlogPost.css'

function Post4() {
    return (
        <div className='blog-content-body'>
            <hr></hr>
            <br></br>
            <br></br>
            <div className='blog_title'><b>프롤로그</b></div>
            <div className='blog_subtitle'>디자인</div>
            <br></br>
            <br></br>
            <b>디자인과 예술은 약간의 유사점이 있지만 다른 개념이다.</b> <br></br><br></br>
            <img className='blog_img' src='https://img1.daumcdn.net/thumb/R1280x0.fjpg/?fname=http://t1.daumcdn.net/brunch/service/user/dlxY/image/BwKzafBUwk2YsivmRrrsNWVWyWA.jpeg'
            width="100%"></img>
            <br></br>
            <br></br>
            <div className='article'>
            디자인은 특정 요구 사항이나 요구 사항에 대한 솔루션을 만드는 해결 활동, 
            &nbsp;즉 특정한 목적을 염두에 두고 무언가를 계획하고 만드는 과정이다.
            &nbsp;개개인의 표현에 중심을 두는 예술은 기계가 대체하는데 한계가 있지만,
            &nbsp;특정문제를 해결하는 디자인은 인공지능에 많은 영향을 받을 수밖에 없다.
            <br></br><b>필자 또한 디자이너기에 걱정이 이만저만이 아니었다.</b>
            <br></br>
            <br></br>
            <img className='blog_img' src='https://img1.daumcdn.net/thumb/R1280x0.fjpg/?fname=http://t1.daumcdn.net/brunch/service/user/dlxY/image/-Iu4DsRJKBkLS_a6IgEFuBm6Gf4.jpeg'
            width="100%"></img>
            <br></br>그렇다면, Chat GPT와 DALL-2와 같은 프로그램이 만들어지고 있는 시대에 이들에게 밀리지 않을 디자인을 하려면 어떤 방식으로 나아가야 할까?
            <br></br>
            <br></br>
            </div>
            <br></br>
            <hr></hr>
            <br></br>
            <br></br>
            <br></br>
            <div className='blog_title'><b>첫번째.</b></div>
            <br></br>
            <div className='article'>
            <b>AI는 렌더링, 즉 결과물을 뽑는 수단이지 디렉션을 제안하지 않는다.</b> 
            &nbsp;특정 작업을 자동화하는 기능을 사용하면 디자인 프로세스의
            &nbsp;효율성과 속도가 향상되어 디자이너가 작업의 보다 창의적이고 혁신적인 측면에 집중할 수 있게 된다.
            &nbsp;기계가 특정 작업을 더 잘 수행할 수 있게 됨에 따라 잠재적으로 디자이너에 대한
            &nbsp;수요가 감소할 수도 있지만 전반적으로 대체는 어렵다.
            &nbsp;빨래할 때에 세탁기가 있어도 손길이 필요한 것처럼 
            &nbsp;인간이 기계에 "무언가를 시켜야" 결과를 뽑아내기 때문이다.
            &nbsp;시킨 결과물이 괜찮은 퀄리티인지, 수정작업은 어떤 방향으로 나아가야 하는지의 해결점을
            &nbsp;도출할 수 있는 안목을 지닌 디자이너의 디렉션은 절대적으로 필요하다.
            </div>
            <br></br>
            <br></br>
            <div className='blog_title'><b>두번째.</b></div>
            <br></br>
            <div className='article'>
            <b>인공지능 알고리즘이 기존 데이터에서 훈련되기 때문에 혁신적이고 창의적인 디자인이 나오지 않는다.</b>
            &nbsp;키워드를 입력하면 똑같은 대답이 나오고 결국 똑같은 디자인만 공장처럼 출력하게 되니까.
            &nbsp;또한 저작권 및 소유권 문제도 해결하기 점점 어려워진다.
            &nbsp;이를 해결하려면 디자이너가 새로운 키워드를 학습시켜 키워드를 뽑아내거나,
            &nbsp;인공지능이 도출한 결과물을 베이스로 삼고 혁신을 첨가하는 것이 필요한데
            &nbsp;결국 이도 절대적으로 인간의 영역이라고 볼 수 있다.
            </div>
            <br></br>
            <br></br>
            <div className='blog_title'><b>세번째.</b></div>
            <div className='article'>
            <br></br><b>인공지능은 포토샵 상위호환의 스마트 툴이다.</b>
            &nbsp;개개인이 그림을 아무리 잘 그려봐야 사진만큼 그릴 수 없는 것처럼,
            &nbsp;포토샵은 인간이 겪는 디자인의 기술적인 영역에 대한 해결 수단이 되어왔다.
            &nbsp;<b>인공지능도 같은 맥락이다.</b>&nbsp;디자이너가 콘셉트 설계 부분을 더 체계적이고 근거 있게 구축할 수 있도록 하여 보다 창의적인 측면에 집중할 수 있도록 도와줄 것이다. 인간보다 빅 데이터를 잘 다루는 인공지능은 고객들의 디자인 선호도 및 행동과 같은 방대한 양의 정보에 액세스 할 수 있다. 디자인 설계에 필요한 데이터를 일일이 모아서 분석하느라 시간을 보냈던 그동안의 과정을 단축시켜주었다고 보면 된다. 인공지능이 분석하는 빅데이터들은 아무래도 무분별한 정보일 가능성이 높기 때문에 가져온 데이터를 진위 확인하여 필터링하는 과정만 거치면 앞선 디자인 설계 부분은 쉽고 빠르게 해결된다. 정보를 정리하는 과정을 인공지능이 해주었으니 Dall-2와 같은 그래픽 인공지능이 출력한 데이터를 기반으로 디자이너는 보다 매력적이고 새로운 제품으로 발전시켜 그동안의 디자인 스텝을 큰 폭으로 축소시킬 수 있게 된다.
            <br></br><b>예시로 든다면 이렇다.</b> 인공지능은 효율적인 색상 선택, 타이포그래피 및 레이아웃을 정해주어 디자인 작업 시 시안작업을 최소화할 수 있도록 돕고, 시간을 절약한 디자이너는 인공지능의 가이드에 따라 보다 혁신적인 디자인을 생성할 수 있도록 하면 된다.
            </div>
            <br></br>
            <br></br>
            <br></br>
            <hr></hr>
            <br></br>
            <br></br>
            <br></br>
            <div className='blog_title'><b>CHAT GPT 왈.</b></div>
            <div className='blog_subtitle'>"디자인을 완벽하게 대체할 수는 없습니다"</div>
            <br></br>
            <img className='blog_img' src='https://img1.daumcdn.net/thumb/R1280x0.fjpg/?fname=http://t1.daumcdn.net/brunch/service/user/dlxY/image/03lAuS7Pls5a0Xe5jjLLmAuwfB8.jpeg'
            width="100%"></img>
            <div className='article'>
            <br></br><b>Chat GPT에 대놓고 물어봤다.</b>
            <br></br>"너희가 디자인의 역할을 완벽하게 대체할 수 있다고 생각하니?"
            <br></br>"Do you think you can completely replace the role of design?"
            <br></br>
            <br></br><b>인공지능의 대답은 이렇다</b>
            <br></br>"디자인은 문제 해결, 공감 및 전략적 사고와 같은 광범위한 기술을 포함하는 매우 창의적이고 미묘한 분야입니다. 인공지능은 자동화 및 데이터 분석을 지원할 수 있지만 아직 인간이 제공하는 창의성과 직관을 복제할 수는 없습니다. 또한 디자인은 종종 최종 제품 그 이상입니다. 여기에는 사용자의 요구와 욕구에 대한 깊은 이해와 문화적, 사회적 맥락에 대한 인식이 포함됩니다. 이를 위해서는 현재 AI의 능력을 넘어선 수준의 공감과 인간 연결이 필요합니다. 
            <br></br>요컨대, AI는 확실히 디자이너에게 유용한 도구가 될 수 있지만 아직 디자인 영역을 완전히 대체할 수는 없습니다. 인간 디자이너는 기능적이고 의미 있는 제품과 서비스를 만들기 위해 고유한 기술과 관점을 가져와 디자인 프로세스에서 중요한 역할을 계속 수행할 것입니다."
            <br></br>
            </div>
            <br></br>
            <br></br>
            <br></br>
            <hr></hr>
            <br></br>
            <br></br>
            <br></br>
            <div className='blog_title'><b>에필로그</b></div>
            <div className='blog_subtitle'>어떻게 이용하느냐</div><br></br>
            <img className='blog_img' src='https://img1.daumcdn.net/thumb/R1280x0.fjpg/?fname=http://t1.daumcdn.net/brunch/service/user/dlxY/image/oz3RRW1k5S_r0yhmuijMgSn9Gic.jpeg'
            width="100%"></img>
             <div className='article'>
            <br></br>
            <br></br><b>막연히 기술의 발전을 두려워할 필요는 없다.</b> 
            <br></br>자동차가 생기며 걸을 일이 줄어들었던 것처럼 단순하게 생각하면 그만이다. 인간의 힘을 더 고도의 기술에 쓸 수 있게 도와주는 과정이라면 기술 발전에 앞서 막을 필요도, 무서워할 필요도 없다는게 개인적인 주관이다.
            <br></br>
            <br></br>&nbsp;<b>이것을 잘 이용하느냐, 못하느냐의 차이가 분명이 있을것이다.</b>
            <br></br>2023년 현재의 인공지능은 정확한 디렉션을 하지 않으면 모호하고 추상적인 답변을 내놓는다. 시각적으로 표현하기 어려운 키워드를 다시 시각적으로 표현할 수 있는 단순한 키워드로 구성하고 설명하라는 일련의 학습단계를 몇 번 거쳐야 쓸만한 데이터가 나오게 된다. 담금질을 한 후 괜찮은 후보들을 뽑아 다시 Dall-2 같은 그래픽 인공지능에 적용할 최적의 키워드로 정리하라는 디렉팅이 있어야 디자인으로써 어설프지 않은 작품이 나오게 된다. 
            <br></br>
            <br></br><b>인공지능은 예측은 할 수 있지만 확신은 할 수 없다.</b>
            <br></br>이러한 공백은 앞으로도 채워지지 않을 것이라고 본다. 정확한지 모호한지 판단하는 것도 인간의 몫이고 괜찮은 작업물인지 아닌지도 디자이너의 판단, 그리고 결과적으로 선택은 사용자의 몫이다. 즉, 기존에 없었던 새로운 변수가 무궁무진하다는 의미이다. 
            <br></br>
            <br></br><b>결론은, 디자이너로써 인공지능에 뒤쳐지지 않는 안목을 가져야 한다는 것이다.</b>
            <br></br>기계에게 부려지지 않고 이들을 이용하려면 예측과 변수에 강한 해결점을 낼 수 있는 고도의 인공지능이 되어야한다. 기회비용측면에서 인공지능을 새롭게 개발하는것보다 차라리 사람을 쓰는게 나을 만큼, 정확한 디렉터가 되는것이다. 
            <br></br>
            <br></br>이 글을 쓰고 당장 밖에 나가서 사람들이 뭘 좋아하는지 연구하러 가봐야겠다. 
            </div>
        </div>
    )
}

export default Post4
